module.exports = __webpack_public_path__ + "static/4x_em_onboarding_3-8d99e1cbac0be94cfb5d40558c84ff0e.png";